import styled from 'styled-components';

export const EnableSchedule = styled.div`
    > * {
        margin: 0px 16px;
    }
`;
